import { createStore, Store } from "@quotientjs/browser-storage"

import { stringValidator } from "@/stores/utils/validators"

export const SESSION_ID_STORAGE_KEY = "quotient-session-id"

export type SessionId = string

export const SessionIdStore: Store<SessionId, "session"> = createStore({
  key: SESSION_ID_STORAGE_KEY,
  validator: stringValidator,
  storageType: "session",
})
